<template>
    <div style="max-height: 100%">
        <img :src="thumbUrl"
             :class="getCSSClass('lightbox-thumbnail')"
             :alt="imageAlt"
             :title="imageAlt"
             v-bind:style="{'max-height': maxThumbHeight}"
             style="max-width:100%"
             v-on:click="toggleZoom">
        <popup :visible="zoom"
               v-on:close="zoom = false"
               :show-close-button="false"
               :container-style="'width: auto; padding: 0px'"
        >
            <div style="position: relative" :class="getCSSClass('lightbox-container')">
                <img :src="imageUrl"
                     :alt="imageAlt"
                     :class="getCSSClass('lightbox-image')"
                     :title="imageAlt"
                     style="max-height: 80vh; object-fit:contain"
                >
                <div style="width: 100%; text-align: center; margin-top: 5px" :class="getCSSClass('lightbox-url-label')">
                    <a :href="imageUrl" target="_blank" v-html="newWindowLabel"></a>
                </div>
                <button style="position: absolute; top: 0px; right: 0px; margin: .5rem;"
                        :class="getCSSClass('lightbox-close-button')"
                        v-on:click="zoom = false"
                        v-html="icon('close')"></button>
            </div>
        </popup>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            imageUrl: {},
            thumbnailUrl: {type: String, default: ''},
            imageAlt: {type: String, default: ''},
            newWindowLabel: {type: String, default: 'Open in new window'},
            maxThumbHeight: {type: String, default: '2em'}
        },
        data: function() {
            return {
                zoom: false
            }
        },
        computed: {
            thumbUrl: function() {
                return this.thumbnailUrl != ''
                    ? this.thumbnailUrl
                    :this.imageUrl;
            }
        },
        methods: {
            toggleZoom: function() {
                this.zoom = !this.zoom;
            }
        },
        mounted() {}
    }
</script>